import { useMemo } from 'react';

import Constants from '../data/Constants';
import { useRegisteredParsers } from './queries/useRegisteredParsers';

const infoProviderLabel = (value) =>
  Constants.infoProvidersSimple.find((option) => option.value === value)?.label || value;

// Derives select options (distinct info providers with their labels, sorted by label) from the
// parsers registered in the backend. Not a query itself — see hooks/queries/useRegisteredParsers.
export const useRegisteredInfoProviderOptions = () => {
  const { registeredParsers, loading, error } = useRegisteredParsers();

  // One memo on purpose: keeps the options identity stable for react-select internals and for
  // consumers' own derived state.
  const options = useMemo(() => {
    const values = registeredParsers.map((parser) => parser.infoProvider);
    return [...new Set(values)]
      .map((value) => ({ value, label: infoProviderLabel(value) }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [registeredParsers]);

  return { options, loading, error };
};
